import React from "react";
import { useTranslation } from 'react-i18next';
import Button from "./ui/button";
import { renderStep } from "../utils/RenderStep";

const TestScenariosList = ({
  testScenarios,
  duplicateTestIds,
  extractStepsByType,
  onRemoveDuplicate,
  onSelectScenario,
  selectedNode,
  loading,
}) => {
  const { t } = useTranslation();
  return (
  <div style={{
    marginTop: '2rem',
    background: '#ffffff',
    borderRadius: '0.75rem',
    padding: '2rem',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    border: '1px solid #e5e7eb'
  }}>
    {/* En-tête modernisé */}
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: '2rem',
      paddingBottom: '1rem',
      borderBottom: '2px solid #f3f4f6'
    }}>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '1rem'
      }}>
        <div style={{
          fontSize: '2rem',
          background: 'linear-gradient(135deg, #3b82f6 0%, #6366f1 100%)',
          borderRadius: '50%',
          width: '60px',
          height: '60px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#ffffff',
          boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)'
        }}>
          🎯
        </div>
        <div>
          <h3 style={{
            fontSize: '1.5rem',
            fontWeight: '700',
            margin: '0',
            color: '#1f2937',
            background: 'linear-gradient(135deg, #3b82f6 0%, #6366f1 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text'
          }}>
            Scénarios de test ({testScenarios.length})
          </h3>
          <p style={{
            fontSize: '0.875rem',
            color: '#6b7280',
            margin: '0.25rem 0 0 0'
          }}>
            Visualisation détaillée des scénarios de test
          </p>
        </div>
      </div>
      
      {duplicateTestIds.length > 0 && (
        <div style={{
          background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
          color: '#ffffff',
          padding: '0.75rem 1.25rem',
          borderRadius: '0.5rem',
          fontSize: '0.875rem',
          fontWeight: '600',
          boxShadow: '0 4px 6px -1px rgba(239, 68, 68, 0.3)',
          display: 'flex',
          alignItems: 'center',
          gap: '0.5rem'
        }}>
          <span style={{ fontSize: '1.25rem' }}>⚠️</span>
          {Math.floor(duplicateTestIds.length / 2)} doublons détectés
        </div>
      )}
    </div>

    {/* Grille de scénarios modernisée */}
    <div style={{
      display: 'grid',
      gap: '1.5rem',
      gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))'
    }}>
      {testScenarios.map((scenario, index) => {
        const stepsArr = extractStepsByType(scenario);
        const steps = stepsArr.flat();
        const isDuplicate = duplicateTestIds.includes(scenario.id);

        return (
          <div
            key={index}
            style={{
              background: isDuplicate 
                ? 'linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%)' 
                : 'linear-gradient(135deg, #ffffff 0%, #f9fafb 100%)',
              border: isDuplicate 
                ? '2px solid #ef4444' 
                : '1px solid #e5e7eb',
              borderRadius: '0.75rem',
              padding: '1.5rem',
              boxShadow: isDuplicate 
                ? '0 10px 15px -3px rgba(239, 68, 68, 0.2), 0 4px 6px -2px rgba(239, 68, 68, 0.1)' 
                : '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
              transition: 'all 0.3s ease',
              position: 'relative',
              overflow: 'hidden'
            }}
            onMouseEnter={(e) => {
              if (!isDuplicate) {
                e.target.style.transform = 'translateY(-2px)';
                e.target.style.boxShadow = '0 10px 25px -5px rgba(0, 0, 0, 0.15), 0 10px 10px -5px rgba(0, 0, 0, 0.1)';
              }
            }}
            onMouseLeave={(e) => {
              if (!isDuplicate) {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)';
              }
            }}
          >
            {/* Indicateur de statut en haut à droite */}
            <div style={{
              position: 'absolute',
              top: '1rem',
              right: '1rem',
              display: 'flex',
              gap: '0.5rem'
            }}>
              {isDuplicate && (
                <span style={{
                  background: '#ef4444',
                  color: '#ffffff',
                  padding: '0.25rem 0.75rem',
                  borderRadius: '9999px',
                  fontSize: '0.75rem',
                  fontWeight: '600',
                  boxShadow: '0 2px 4px rgba(239, 68, 68, 0.3)'
                }}>
                  DOUBLON
                </span>
              )}
            </div>

            {/* Contenu principal */}
            <div style={{ marginBottom: '1.5rem' }}>
              {/* Titre du scénario */}
              <h4 style={{
                fontSize: '1.125rem',
                fontWeight: '600',
                margin: '0 0 1rem 0',
                color: '#1f2937',
                lineHeight: '1.4',
                paddingRight: isDuplicate ? '6rem' : '0'
              }}>
                {scenario.title || `Scénario de test #${index + 1}`}
              </h4>

              {/* Métadonnées */}
              <div style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '0.5rem',
                marginBottom: '1rem'
              }}>
                {scenario.nodeName && (
                  <span style={{
                    background: 'linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)',
                    color: '#1e40af',
                    padding: '0.375rem 0.75rem',
                    borderRadius: '0.5rem',
                    fontSize: '0.75rem',
                    fontWeight: '600',
                    border: '1px solid #93c5fd'
                  }}>
                    📋 Pour: {scenario.nodeName}
                  </span>
                )}
                
                {scenario.status && (
                  <span style={{
                    background: '#f3f4f6',
                    color: '#4b5563',
                    padding: '0.375rem 0.75rem',
                    borderRadius: '0.5rem',
                    fontSize: '0.75rem',
                    fontWeight: '500'
                  }}>
                    {scenario.status}
                  </span>
                )}
                
                {["automatisé", "exploratoire", "acceptance"].includes(scenario.type) && (
                  <span style={{
                    background: scenario.type === 'automatisé' 
                      ? 'linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%)' 
                      : scenario.type === 'exploratoire'
                      ? 'linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)'
                      : 'linear-gradient(135deg, #e0e7ff 0%, #c7d2fe 100%)',
                    color: scenario.type === 'automatisé' 
                      ? '#15803d' 
                      : scenario.type === 'exploratoire'
                      ? '#d97706'
                      : '#3730a3',
                    padding: '0.375rem 0.75rem',
                    borderRadius: '0.5rem',
                    fontSize: '0.75rem',
                    fontWeight: '600',
                    border: scenario.type === 'automatisé' 
                      ? '1px solid #86efac' 
                      : scenario.type === 'exploratoire'
                      ? '1px solid #fcd34d'
                      : '1px solid #a5b4fc'
                  }}>
                    {scenario.type === 'automatisé' && '🤖 '}
                    {scenario.type === 'exploratoire' && '🔍 '}
                    {scenario.type === 'acceptance' && '✅ '}
                    {scenario.type.charAt(0).toUpperCase() + scenario.type.slice(1)}
                  </span>
                )}
              </div>

              {/* Étapes du scénario */}
              {steps.length > 0 && (
                <div style={{
                  background: 'rgba(59, 130, 246, 0.05)',
                  borderRadius: '0.5rem',
                  padding: '1rem',
                  border: '1px solid rgba(59, 130, 246, 0.1)'
                }}>
                  <h5 style={{
                    fontSize: '0.875rem',
                    fontWeight: '600',
                    margin: '0 0 0.75rem 0',
                    color: '#374151',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem'
                  }}>
                    <span>📝</span> Étapes du scénario
                  </h5>
                  <ul style={{
                    listStyle: 'none',
                    margin: '0',
                    padding: '0',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '0.5rem'
                  }}>
                    {steps.slice(0, 3).map((step, i) => (
                      <li key={i} style={{
                        fontSize: '0.8rem',
                        color: '#4b5563',
                        padding: '0.5rem',
                        background: '#ffffff',
                        borderRadius: '0.375rem',
                        border: '1px solid #e5e7eb',
                        display: 'flex',
                        alignItems: 'flex-start',
                        gap: '0.5rem'
                      }}>
                        <span style={{
                          color: '#3b82f6',
                          fontWeight: '600',
                          fontSize: '0.75rem',
                          background: '#dbeafe',
                          borderRadius: '50%',
                          width: '1.5rem',
                          height: '1.5rem',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          flexShrink: 0
                        }}>
                          {i + 1}
                        </span>
                        <span style={{ lineHeight: '1.4' }}>
                          {renderStep(step)}
                        </span>
                      </li>
                    ))}
                    {steps.length > 3 && (
                      <li style={{
                        fontSize: '0.8rem',
                        color: '#6b7280',
                        fontStyle: 'italic',
                        textAlign: 'center',
                        padding: '0.5rem'
                      }}>
                        ... et {steps.length - 3} autres étapes
                      </li>
                    )}
                  </ul>
                </div>
              )}
            </div>

            {/* Actions */}
            <div style={{
              display: 'flex',
              gap: '0.75rem',
              justifyContent: 'flex-end',
              alignItems: 'center',
              paddingTop: '1rem',
              borderTop: '1px solid #e5e7eb'
            }}>
              {isDuplicate && (
                <Button
                  onClick={() => onRemoveDuplicate(scenario.id)}
                  style={{
                    background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
                    color: '#ffffff',
                    border: 'none',
                    padding: '0.75rem 1.25rem',
                    borderRadius: '0.5rem',
                    fontSize: '0.875rem',
                    fontWeight: '600',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                    boxShadow: '0 4px 6px -1px rgba(239, 68, 68, 0.3)',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.transform = 'translateY(-1px)';
                    e.target.style.boxShadow = '0 10px 15px -3px rgba(239, 68, 68, 0.4)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = '0 4px 6px -1px rgba(239, 68, 68, 0.3)';
                  }}
                >
                  <span>🗑️</span> Supprimer doublon
                </Button>
              )}
              <Button
                onClick={() => onSelectScenario(scenario)}
                style={{
                  background: 'linear-gradient(135deg, #3b82f6 0%, #6366f1 100%)',
                  color: '#ffffff',
                  border: 'none',
                  padding: '0.75rem 1.25rem',
                  borderRadius: '0.5rem',
                  fontSize: '0.875rem',
                  fontWeight: '600',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  boxShadow: '0 4px 6px -1px rgba(59, 130, 246, 0.3)',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem'
                }}
                onMouseEnter={(e) => {
                  e.target.style.transform = 'translateY(-1px)';
                  e.target.style.boxShadow = '0 10px 15px -3px rgba(59, 130, 246, 0.4)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = '0 4px 6px -1px rgba(59, 130, 246, 0.3)';
                }}
              >
                <span>👁️</span> Visualiser
              </Button>
            </div>
          </div>
        );
      })}
    </div>

    {/* Message si aucun scénario */}
    {testScenarios.length === 0 && (
      <div style={{
        textAlign: 'center',
        padding: '3rem 2rem',
        color: '#6b7280'
      }}>
        <div style={{
          fontSize: '4rem',
          marginBottom: '1rem',
          opacity: 0.5
        }}>📋</div>
        <h3 style={{
          fontSize: '1.25rem',
          fontWeight: '600',
          margin: '0 0 0.5rem 0',
          color: '#374151'
        }}>
          Aucun scénario de test
        </h3>
        <p style={{
          fontSize: '0.875rem',
          margin: '0',
          maxWidth: '400px',
          marginLeft: 'auto',
          marginRight: 'auto',
          lineHeight: '1.5'
        }}>
          Aucun scénario de test n'a été trouvé. Commencez par créer vos premiers scénarios pour améliorer la couverture de test.
        </p>
      </div>
    )}
  </div>
  );
};

export default TestScenariosList;